export default __webpack_public_path__ + "static/section_9_item_4-0892c07a0d6a381435fead9b57998f4d.png";